// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-logo',
    props: {
        logoMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
    computed: {
        versionVariant() {
            if (utils.isEmpty(this.$host.config.versionState)) {
                return "fallback";
            }
            else {
                return this.$host.config.versionState;
            }
        },
    }
});
// #endregion
